import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function WaitlistDecline() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const reg = searchParams.get('reg');

  const [state, setState] = useState('confirm'); // confirm | declining | done | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleDecline = async () => {
    if (!code || !reg) {
      setState('error');
      setErrorMsg('Invalid link — missing code or registration ID.');
      return;
    }

    setState('declining');
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/flight/decline-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code, reg })
      });
      const data = await res.json();
      if (data.status === 'success') {
        setState('done');
      } else {
        setState('error');
        setErrorMsg(data.message || 'Something went wrong.');
      }
    } catch (err) {
      setState('error');
      setErrorMsg(err.message || 'Network error. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-blue-700 px-6 py-5 text-center">
          <div className="flex items-center justify-center gap-4 mb-3">
            <img src="/igud-logo.png" alt="Igud Yeshivos" className="h-10 w-auto" />
            <img src="/ehk-logo_2-1.png" alt="Eretz Hakodesh" className="h-10 w-auto" />
          </div>
          <h1 className="text-white font-bold text-xl">Charter Flight</h1>
        </div>

        <div className="px-6 py-8">
          {state === 'confirm' && (
            <div className="text-center">
              <div className="text-4xl mb-4">✈️</div>
              <h2 className="text-xl font-bold text-gray-800 mb-3">Release Your Spot?</h2>
              <p className="text-gray-600 mb-6">
                If you release your spot, it will be offered to the next person on the waiting list.
                <strong className="block mt-2 text-red-600">This cannot be undone.</strong>
              </p>
              <div className="flex gap-3 justify-center">
                <button
                  onClick={handleDecline}
                  className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg"
                >
                  Yes, Release My Spot
                </button>
                <a
                  href={code && reg ? `/checkout?code=${code}&reg=${reg}` : '/'}
                  className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg inline-block"
                >
                  No, Keep My Spot
                </a>
              </div>
            </div>
          )}

          {state === 'declining' && (
            <div className="text-center">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-400 mx-auto mb-4"></div>
              <p className="text-gray-600">Processing…</p>
            </div>
          )}

          {state === 'done' && (
            <div className="text-center">
              <div className="text-4xl mb-4">🙏</div>
              <h2 className="text-xl font-bold text-gray-800 mb-2">Thank You</h2>
              <p className="text-gray-600">
                Your spot has been released. We appreciate you letting us know — it means someone else on the list will get a chance to travel.
              </p>
              <p className="text-gray-500 text-sm mt-4">
                Questions? <a href="mailto:flights@igudys.com" className="text-blue-600 underline">flights@igudys.com</a>
              </p>
            </div>
          )}

          {state === 'error' && (
            <div className="text-center">
              <div className="text-4xl mb-4">⚠️</div>
              <h2 className="text-xl font-bold text-gray-800 mb-2">Something Went Wrong</h2>
              <p className="text-gray-600 mb-4">{errorMsg}</p>
              <p className="text-gray-500 text-sm">
                Please contact us at{' '}
                <a href="mailto:flights@igudys.com" className="text-blue-600 underline">flights@igudys.com</a>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
